import { cleanToken } from '@nitra/components/njs/token.js'

const routes = [
  {
    path: '/',
    component: () => import('layouts/Layout.vue'),
    children: [
      { path: '', component: () => import('pages/Index.vue') },
      {
        path: '/issues/:pos?',
        name: 'issues',
        meta: { roles: 'issue' },
        component: () => import('pages/Issues.vue')
      },
      {
        path: '/issue/:id',
        name: 'issue',
        meta: { roles: 'issue' },
        component: () => import('pages/Issue.vue')
      },
      {
        path: '/issue-hud',
        meta: { roles: 'issue-hud' },
        component: () => import('pages/IssueHud.vue')
      },
      {
        path: '/calls',
        name: 'calls',
        meta: { roles: 'call' },
        component: () => import('pages/Calls.vue')
      },
      {
        path: '/call-hud/:demo?',
        meta: { roles: 'call-hud' },
        component: () => import('pages/CallHud.vue')
      },
      {
        path: '/call-analysis/:id',
        meta: { roles: 'call-analysis' },
        component: () => import('pages/CallAnalysis.vue')
      },
      {
        path: '/dashboard/operator-status',
        meta: { roles: 'dashboard-operator' },
        component: () => import('pages/dashboard/OperatorStatus.vue')
      },
      // {
      //   path: '/dashboard/incoming-calls',
      //   meta: { roles: 'dashboard-operator' },
      //   component: () => import('pages/dashboard/IncomingCalls.vue')
      // },
      {
        path: '/dashboard/incoming-calls2',
        meta: { roles: 'dashboard-operator' },
        component: () => import('pages/dashboard/IncomingCalls2.vue')
      },
      // {
      //   path: '/dashboard/cxc-telecontact',
      //   meta: { roles: 'dashboard-operator' },
      //   component: () => import('pages/dashboard/CXC-telecontact.vue')
      // },
      {
        path: '/report/operator-status',
        meta: { roles: 'report-operator' },
        component: () => import('pages/report/OperatorStatus.vue')
      },
      // {
      //   path: '/report/call-phone-without-pos',
      //   meta: { roles: 'report-phone' },
      //   component: () => import('pages/report/CallPhoneWithoutPos.vue')
      // },
      {
        path: '/report/orders-by-period',
        meta: { roles: 'report-issue' },
        component: () => import('pages/report/OrdersByPeriod.vue')
      },
      {
        path: '/report/da',
        meta: { roles: 'report-da' },
        component: () => import('pages/report/DA.vue')
      },
      {
        path: '/demo/calls',
        meta: { roles: 'demo' },
        component: () => import('pages/demo/Calls.vue')
      },
      {
        path: '/demo/survey',
        meta: { roles: 'demo' },
        component: () => import('pages/demo/Survey.vue')
      },
      {
        path: '/demo/team',
        meta: { roles: 'demo' },
        component: () => import('pages/demo/TeamProgress.vue')
      },
      {
        path: '/sms',
        meta: { roles: 'sms-bulk' },
        component: () => import('pages/Sms.vue')
      },
      {
        path: '/oos',
        meta: { roles: 'oos' },
        component: () => import('pages/oos/Oos.vue')
      },
      {
        path: '/oos/dashboard-total',
        meta: { roles: 'oos-dashboard' },
        component: () => import('pages/oos/DashboardTotal.vue')
      },
      {
        path: '/oos/dashboard-reason-kam',
        meta: { roles: 'oos-dashboard' },
        component: () => import('pages/oos/DashboardReasonKam.vue')
      },
      {
        path: '/oos/dashboard-reason-tpd',
        meta: { roles: 'oos-dashboard' },
        component: () => import('pages/oos/DashboardReasonTpd.vue')
      },
      {
        path: '/oos/dashboard-time',
        meta: { roles: 'oos-dashboard' },
        component: () => import('pages/oos/DashboardTime.vue')
      },
      {
        path: '/oos/dashboard-repeated',
        meta: { roles: 'oos-dashboard' },
        component: () => import('pages/oos/DashboardOosRepeated.vue')
      },
      {
        path: '/oos/dashboard-oos-by-kam',
        meta: { roles: 'oos-dashboard' },
        component: () => import('pages/oos/DashboardOosByKam.vue')
      },
      {
        path: '/oos/dashboard-visual-bf',
        meta: { roles: 'oos-dashboard' },
        component: () => import('pages/oos/DashboardVisualBF.vue')
      },
      {
        path: '/oos/product',
        meta: { roles: 'oos' },
        component: () => import('pages/oos/Product.vue')
      },
      {
        path: '/oos/ship-to',
        meta: { roles: 'oos' },
        component: () => import('pages/oos/ShipTo.vue')
      }
    ]
  },
  {
    path: '/logout',
    beforeEnter: (_to, from, next) => {
      // Записуємо поточний урл в session storage
      // щоб потім на нього повернути після логіну
      sessionStorage.setItem('url-before-logout', from.path)

      // remove auth cookie
      cleanToken()
      next('/login')
    }
  },
  {
    path: '/login',
    component: () => import('layouts/Blank.vue'),
    children: [
      { path: '/login', component: () => import('pages/login/Login.vue') },
      { path: '/code', component: () => import('pages/login/Code.vue') }
    ]
  }
]

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  })
}
if (process.env.COUNTRY === 'ru') {
  routes.push({
    path: '/',
    component: () => import('layouts/Layout.vue'),
    children: [
      {
        path: '/dashboard/cxc-telecontact',
        meta: { roles: 'dashboard-operator' },
        component: () => import('pages/dashboard/CXC-telecontact.vue')
      }
    ]
  })
}
if (process.env.COUNTRY === 'ua') {
  routes.push({
    path: '/',
    component: () => import('layouts/Layout.vue'),
    children: [
      {
        path: '/dashboard/incoming-calls',
        meta: { roles: 'dashboard-operator' },
        component: () => import('pages/dashboard/IncomingCalls.vue')
      }
    ]
  })
}

export default routes
